import React, { FunctionComponent } from 'react';
import { FaceCaptureModal } from '../../../components/FaceCaptureModal/FaceCaptureModal';
import { ModalDialog } from '../../../components/Modals/ModalDialog';

export const FaceCheck: FunctionComponent<{
  showFaceCheckModal: boolean;
  loading: boolean;
  error: string | null;
  hideFaceCheckModal: () => void;
  processFaceVideo: (blob: Blob) => void;
  setError: (message: string | null) => void;
}> = ({
  showFaceCheckModal,
  loading,
  error,
  hideFaceCheckModal,
  processFaceVideo,
  setError,
}) => {
  if (!showFaceCheckModal) {
    return null;
  }

  if (error) {
    return (
      <ModalDialog
        small
        center
        title="Error"
        show
        onHide={() => {
          setError(null);
        }}
      >
        <div>{error}</div>
      </ModalDialog>
    );
  }

  return (
    <>
      <FaceCaptureModal
        uploading={loading}
        show
        onCompleted={hideFaceCheckModal}
        onFinishedRecording={(blob) => {
          processFaceVideo(blob);
        }}
      />
    </>
  );
};
